import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Check, CreditCard, Icon } from '../ui/Icon';
import Modal from '../ui/Modal';
import Spinner from '../ui/Spinner';
import { billingApi } from '../../api/billing.api';
import { toast } from '../ui/Toast';

interface Props {
  open: boolean;
  onClose: () => void;
}

export default function PaywallModal({ open, onClose }: Props) {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);

  async function handleBuy() {
    setLoading(true);
    try {
      const { url } = await billingApi.createProCheckout();
      window.location.href = url;
    } catch {
      toast(t('billing.paywall.error'), 'error');
      setLoading(false);
    }
  }

  return (
    <Modal open={open} onClose={onClose} title={t('billing.paywall.title')} size="sm">
      <div className="space-y-4">
        <div className="text-center py-2">
          <div className="text-4xl mb-3">✈️</div>
          <p className="text-sm text-slate-600 dark:text-slate-400 leading-relaxed">
            {t('billing.paywall.description')}
          </p>
        </div>

        {/* The price is Stripe's (and each store's), shown on checkout: it is
            not repeated here so it can change without a release. */}
        <ul className="bg-teal-50 dark:bg-teal-950/40 border border-teal-200 dark:border-teal-800 rounded-xl p-4 space-y-2">
          {(t('billing.paywall.perks', { returnObjects: true }) as string[]).map(perk => (
            <li key={perk} className="flex items-center gap-2 text-sm text-teal-800 dark:text-teal-200">
              <Icon as={Check} size={16} className="shrink-0 text-teal-600 dark:text-teal-400" />
              {perk}
            </li>
          ))}
        </ul>

        <button onClick={handleBuy} disabled={loading} className="btn-primary w-full gap-2">
          {loading ? <Spinner size="sm" /> : <Icon as={CreditCard} size={16} />}
          {t('billing.paywall.cta')}
        </button>
        <button onClick={onClose} className="btn-secondary w-full">
          {t('common.cancel')}
        </button>
      </div>
    </Modal>
  );
}
